'use strict';

const _=require('pulsar-utils/dist-es6/_');
const{DataSet,Timeline}=require('vis-timeline');
const Formatters=require('../../../../dist-es6/client/formatters');
const{ScheduleRowAxisDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowAxisDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ForecastRowAxisDirective=class ForecastRowAxisDirective extends BaseControllerBackedDirective{
get template(){return''}

get objectBindings(){return['axisBounds','currentTime']}

get $inject(){return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}

get controller(){return ForecastRowAxisController}};let






ForecastRowAxisController=class ForecastRowAxisController extends ScheduleRowAxisDirectiveController{
constructor($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){
super($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService);
this._$timeout(()=>{
const _forecastTimelineOptions={
timeAxis:{
scale:'hour',
step:2},

format:{
minorLabels:(date,scale,step)=>this._momentWithTimeZoneForTimeline(date).format('h:mm')}};



this._timeline.setOptions(_forecastTimelineOptions);
this._scheduleRowScrollingService.updateScheduleRowOptions(_forecastTimelineOptions);

this._redraw();
});
}

_setupWatchers(){
this._$scope.$watch('controller.axisBounds',(newAxisBounds,oldAxisBounds)=>{
if(this._timeline){
this._timeline.setOptions({
min:newAxisBounds.start,
max:newAxisBounds.end});

}

this.__updateAxisWindowAndAllScheduleWindows({start:newAxisBounds.start,end:newAxisBounds.end},0);

this._redraw();
});

this._$scope.$watch('controller.currentTime',(newVal,oldVal)=>this._redraw());
this._$scope.$on('$destroy',()=>this._scheduleRowScrollingService.setAxis(null));
}

_updateData(){
const currentTime={
id:'current-time',
start:this.currentTime,
type:'point',
className:'current-time'};


const pastMask={
id:'past-mask',
start:this.axisBounds.start,
end:this.currentTime,
type:'range',
className:'past-mask'};


this._dataset.update([pastMask,currentTime]);
}};


module.exports=ForecastRowAxisDirective;
//# sourceMappingURL=forecastRowAxisDirective.js.map
